import authService from './authService';

const API_BASE_URL = 'https://uni-func-pd-thrive360.azurewebsites.net';

export async function fetchRtmdData(countryCode = 'laos', daysSummary = 7, daysAlarms = 30) {
  const params = new URLSearchParams({ country: countryCode, daysSummary: String(daysSummary), daysAlarms: String(daysAlarms) });
  const url = `${API_BASE_URL}/api/rtmd?${params.toString()}`;
  const idToken = await authService.getIdToken();
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`
    }
  });
  if (!response.ok) {
    let message = `Failed to fetch RTMD data (${response.status})`;
    try {
      const err = await response.json();
      if (err?.error) message = err.error;
    } catch (_) {}
    throw new Error(message);
  }
  return await response.json();
}


